import CodeMirror from 'codemirror';

import 'codemirror/theme/idea.css';
import 'codemirror/theme/lucario.css';

import 'codemirror/addon/runmode/runmode';

import 'codemirror/mode/javascript/javascript';
import 'codemirror/mode/css/css';
import 'codemirror/mode/xml/xml';
import 'codemirror/mode/sql/sql';
import 'codemirror/mode/markdown/markdown';
import 'codemirror/mode/python/python';
import 'codemirror/mode/shell/shell';
import 'codemirror/mode/jsx/jsx';

export const LANG_MODE = {
    js: 'javascript', javascript: 'javascript', ts: 'javascript', typescript: 'javascript',
    jsx: 'jsx', tsx: 'jsx',
    css: 'css', scss: 'css', less: 'css',
    html: 'xml', xml: 'xml',
    sql: 'sql',
    md: 'markdown', markdown: 'markdown',
    py: 'python', python: 'python',
    sh: 'shell', bash: 'shell', shell: 'shell',
};

export const codeMirrorThemeClass = theme =>
    (theme?.material?.palette?.type === 'dark' ? 'cm-s-lucario' : 'cm-s-idea');

export default CodeMirror;
